module.exports = __webpack_public_path__ + "media/images/gallery/constellations/corona_australis/cra_gc-a677f1bf7c885f51d99268629bce779c.gif";